import smavaIllustration from 'assets/icons/voucher-money-smava-full.png'
import ffgIllustration from 'assets/icons/voucher-money-ffg-full.png'
import { VoucherBannerVariant } from '../../VoucherBanner.types'

export const VARIANT_COPY: Record<
  VoucherBannerVariant,
  {
    subtitle: string
    illustration: string
    title: (amount: number | null) => string
  }
> = {
  smava: {
    subtitle: 'Nur bei smava.',
    illustration: smavaIllustration,
    title: (amount) => {
      return amount != null
        ? `${amount} € Gutschein erhalten!`
        : 'Gutschein erhalten!'
    }
  },
  ffg: {
    subtitle: 'Jetzt bei FINANZCHECK.',
    illustration: ffgIllustration,
    title: (amount) => {
      return amount != null
        ? `${amount} € Gutschein erhalten!`
        : 'Gutschein erhalten!'
    }
  }
}
